import { vendorTypes } from "../types";
import vendorApi from "../api/vendorApi";

export const createVendor = (data) => {
//   const formData = new FormData();
//   Object.keys(data).forEach((key) => formData.append(key, data[key]));
  return {
    type: vendorTypes.CREATE_VENDOR,
    payload: {
      request: {
        url: vendorApi.CREATE_VENDOR,
        method: "post",
        data: data,
        headers: {
          "Content-type": "application/json",
        },
      },
    },
  };
};

export const getvendors = () => {
  return {
    type: vendorTypes.GET_ALL_VENDORS,
    payload: {
      request: {
        url: vendorApi.GET_ALL_VENDORS,
        method: "get",
      },
    },
  };
};

export const updateVendor = (data) => {
//   const formData = new FormData();
//   Object.keys(data).forEach((key) => formData.append(key, data[key]));
  return {
    type: vendorTypes.UPDATE_VENDOR,
    payload: {
      request: {
        url: vendorApi.UPDATE_VENDOR,
        method: "PUT",
        data: data,
        headers: {
          "Content-type": "application/json",
        },
      },
    },
  };
};

export const deleteVendor = (data) => {
  return {
    type: vendorTypes.DELETE_VENDOR,
    payload: {
      request: {
        url: vendorApi.DELETE_VENDOR,
        method: "delete",
        data: {id: data},
      },
    },
  };
};